// Utility to sync React state with the feedback widget
declare global {
  interface Window {
    WIDGET_CONFIG?: any;
    updateWidgetConfig?: (updates: any) => void;
  }
}

interface WidgetData {
  // Customer info
  firstName?: string;
  surname?: string;
  email?: string;
  
  // Current selection
  currentImageUrl?: string;
  currentAddress?: string;
  currentFrameUrl?: string;
  currentStyle?: string;
  
  // Product info - artworkUrl is the primary artwork (watercolor)
  artworkUrl?: string; // Primary artwork URL (watercolor)
  frameUrl?: string;
  selectedFrame?: string;
  selectedStyle?: string;
  selectedSize?: string;
  
  // All style images (flattened)
  watercolorUrl?: string; // Same as artworkUrl (watercolor is primary)
  pencilUrl?: string;
  oilUrl?: string;
  
  // Page context
  page?: string;
  source?: string;
  propertySearchId?: string;
  
  // Order info
  orderId?: string;
  hasCompletedOrder?: boolean;
  
  // Pricing
  productPrice?: number;
  shippingCost?: number;
  totalPrice?: number;
  
  [key: string]: any;  // Allow additional properties
}

/**
 * Update the feedback widget with current user context
 * DISABLED: Widget has been removed
 */
export const updateWidgetData = (data: WidgetData) => {
  // Widget disabled - do nothing
  return;
};

/**
 * Update widget when user enters configurator
 * DISABLED: Widget has been removed
 */
export const updateWidgetForConfigurator = (
  imageUrl?: string | null,
  address?: string | null,
  propertySearchId?: string | null,
  allImageUrls?: Record<string, string | null>,
  frameUrl?: string | null,
  selectedFrame?: string | null,
  email?: string | null
) => {
  // Widget disabled - do nothing
  return;
};

/**
 * Update widget when user changes image style or frame in configurator
 * DISABLED: Widget has been removed
 */
export const updateWidgetCurrentImage = (
  imageUrl: string, 
  style: string,
  frameUrl?: string,
  selectedFrame?: string
) => {
  // Widget disabled - do nothing
  return;
};

/**
 * Update widget when user fills out order form
 * DISABLED: Widget has been removed
 */
export const updateWidgetForOrderForm = (
  firstName: string,
  lastName: string,
  email: string,
  address?: string,
  artworkUrl?: string,
  frameUrl?: string,
  selectedFrame?: string,
  selectedStyle?: string,
  selectedSize?: string,
  productPrice?: number,
  shippingCost?: number,
  totalPrice?: number
) => {
  // Widget disabled - do nothing
  return;
};

/**
 * Update widget on success page
 * DISABLED: Widget has been removed
 */
export const updateWidgetForSuccess = (
  email?: string,
  orderId?: string
) => {
  // Widget disabled - do nothing
  return;
};

/**
 * Update widget on landing page
 * DISABLED: Widget has been removed
 */
export const updateWidgetForLanding = () => {
  // Widget disabled - do nothing
  return;
};

